import Vue from 'vue'
import Vuex from 'vuex'
// import settings from './modules/settings'
// import menu from './modules/menu'
// import user from './modules/user'

import locale from './modules/locale'
import site from './modules/site'
import categories from './modules/categories'
import positionTop from './modules/positionTop'
import music from './modules/music'
import createLogger from '@/store/plugins/loggers'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    locale,
    site,
    categories,
    positionTop,
    music
    // menu,
    // settings,
    // user
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
